import { useUserStore } from "@/stores/models/account";

export default async function userExists({ to }) {
    let exists = false;
    let cId = to.params.userId;
    if (cId) {
        try {
            const userStore = useUserStore();
            let existing = userStore.item(cId);
            if (!existing) {
                await userStore.fetchItem({
                    query: { id: cId },
                    key: "VIEW_USER"
                });
            }

            exists = true;
        } catch (err) {
            exists = false;
        }
    }

    if (!exists) {
        return {
            name: "Not Found"
        };
    }
}
